import React, {useEffect, useState, Suspense, useRef} from "react";
import {Button, Tooltip, IconButton,} from "@mui/material";
import {backgroundColor, colorSecondary, monacoTheme} from "../../App/theme.js";
import {AutoAwesome} from "@mui/icons-material";

const LazyEditor = React.lazy(() => import('@monaco-editor/react'));

const defaultURLProcessorCode = `
// Edit this function to filter page urls
function urlProcessor(urls) {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.tiff', '.svg'];
    
    return urls.filter(url => {
        // filter out image urls
        return !imageExtensions.some(ext => url.toLowerCase().endsWith(ext));
    });
}
`;

const defaultPageProcessor = `
// Edit this function to manipulate the page items
function pageProcessor(pages) {
    return pages.filter(Boolean).map(page => {
        
        // Limit the title to 256 characters
        page.title = page.title?.slice(0, 256);
        
        // page.description - The description of the page       
        // page.content - The content of the page 
        // page.image - The image URL of the page
        // page.price - The price of the page (float)
        // page.currency - The currency of the price
        // page.url - The URL of the page
        
        return page;
    });
}
`;

export const handleURLProcessor = ({STATUS, status, URLProcessorCode, setUrlArray, setTextAreaData, urlArray,
                                       batchResponses, pageProcessorCode, setBatchResponses, setImportPagesFilterDone, setParseURLsFilterDone}) => {
    try {
        if (status === STATUS.PARSE_URLS ) {
            const userURLProcessor = eval(`(${URLProcessorCode})`);
            const newURLSArray = userURLProcessor(urlArray);
            setUrlArray(newURLSArray);
            setTextAreaData(newURLSArray.join('\n'));
            setParseURLsFilterDone(true)
        } else {
            const userPageProcessor = eval(`(${pageProcessorCode})`);
            setBatchResponses(userPageProcessor(batchResponses));
            setImportPagesFilterDone(true)
        }
    } catch (error) {
        console.error("Error evaluating the function:", error);
        alert("Error in function. Please check the syntax.");
    }
}

const ProcessorFunction = ({ setUrlArray, STATUS, status, urlArray, setTextAreaData, batchResponses,
    setBatchResponses, hideEditor, sx, setImportPagesFilterDone, setParseURLsFilterDone, parseRef, importRef }) => {

    const [URLProcessorCode, setURLProcessorCode] = useState(() => {
        const savedState = localStorage.getItem('URLProcessorCode');
        return savedState !== null ? JSON.parse(savedState) : defaultURLProcessorCode;
    });

    useEffect(() => {
        localStorage.setItem('URLProcessorCode', JSON.stringify(URLProcessorCode));
    }, [URLProcessorCode]);

    const [pageProcessorCode, setPageProcessorCode] = useState(() => {
        const savedState = localStorage.getItem('pageProcessorCode');
        return savedState !== null ? JSON.parse(savedState) : defaultPageProcessor;
    });

    useEffect(() => {
        localStorage.setItem('pageProcessorCode', JSON.stringify(pageProcessorCode));
    }, [pageProcessorCode]);

    const myRef = status === STATUS.PARSE_URLS ? parseRef : importRef;

    return (
        <div style={{ padding: 0 }}>
            <Tooltip title="Apply" placement={"top-start"}>
                <Button
                    ref={myRef}
                    sx={sx ? sx : {mt: 2, mb: 2}}
                    variant="outlined"
                    onClick={() => handleURLProcessor({STATUS, status, URLProcessorCode, setUrlArray, setTextAreaData, urlArray,
                        batchResponses, pageProcessorCode, setBatchResponses, setImportPagesFilterDone, setParseURLsFilterDone})}
                >
                    {status === STATUS.PARSE_URLS ? `Filter URLs`: `Process Pages`}
                </Button>
            </Tooltip>

            {!hideEditor && <div style={{ position: 'relative' }}>
                <Suspense fallback={<div>Loading...</div>}>
                    {/*@Todo implementation */}
                    {/*<Tooltip title="AI: Reads comments and generates code. Try it!" placement={"top-start"}>*/}
                    {/*    <IconButton*/}
                    {/*        // onClick={() => setPageProcessorCode(prevCode => prevCode + 'a')}*/}
                    {/*        style={{*/}
                    {/*            position: 'absolute',*/}
                    {/*            top: 2,*/}
                    {/*            left: 2,*/}
                    {/*            zIndex: 10,*/}
                    {/*            background: 'transparent',*/}
                    {/*            border: 'none',*/}
                    {/*            cursor: 'pointer'*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <AutoAwesome style={{ color: colorSecondary }} />*/}
                    {/*    </IconButton>*/}
                    {/*</Tooltip>*/}
                    <LazyEditor
                        options={{
                            padding: { top: 30 },
                            scrollbar: {
                                scrollByItem: true,
                                readOnly: false,
                            },
                            minimap: { enabled: false }
                        }}
                        height="300px"
                        defaultLanguage="javascript"
                        value={status === STATUS.PARSE_URLS ? URLProcessorCode : pageProcessorCode}
                        onChange={(v) => {
                            if (status === STATUS.PARSE_URLS) {
                                setURLProcessorCode(v)
                            } else {
                                setPageProcessorCode(v)
                            }
                        }}
                        language="javascript"
                        theme={`custom-${monacoTheme}`}
                        beforeMount={(monaco) => {
                            monaco.editor.defineTheme(`custom-${monacoTheme}`, {
                                base: monacoTheme,
                                inherit: true,
                                rules: [],
                                colors: {
                                    'editor.background': backgroundColor,
                                }
                            });
                        }}
                    />
                </Suspense>
            </div>}
        </div>
    );
};

export default ProcessorFunction;